// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"62464f7f","732":"45021131","977":"9eb5c151"}[chunkId] + ".chunk.js";
};